export const data1 = {
    success: true,
    data: {
        userDetails: {
            _id: '5ef0fb9ad373758c837e79e1',
            name: 'John Doe',
            email: 'john@dashclicks.com',
            first_name: 'John',
            last_name: 'Doe',
            phone: '+17602807978',
            image: 'https://s3.wasabisys.com/open/assets/team-placeholder.png',
            businessName: 'Account #1',
        },
        businessDetails: {
            name: 'Roto-Rooter Plumbing & Water Cleanup',
            address: {
                city: 'Doral',
                state_province: 'Florida',
                country: 'United States',
                unit: '7847',
                suite: 'Northwest',
                street: ' 15th Street',
                zip: '33126',
            },
            phoneNumber: '+13055210281',
            website: 'https://www.rotorooter.com',
            businessCategory: 'Manufacturing',
            photos: [
                'https://lh5.googleusercontent.com/p/AF1QipOax9YQ-Raa5c9OA3WUQ-W5vdquIpXYexeb7enm=s435-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipMOWEGQ8WUSesR3zMfV-d1DT3KIR3t6y6Z_75sT=s435-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipNKKI7zT02phfhvv0h3joHkkPyNeMOjGOr1Gb_9=s387-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipMeXf2XIJuHO2kHqicI3FEUU7VpVjKlto_dxwOP=s436-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipPXQ5GGSzdpipU0I8n54HWZYPjDogYYlMtZpYlT=s508-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipPOSzU2TGP4mwbNhx7gv-ZEKzBqGEi0NaqoAyw0=s435-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipMiVLEZ6ZGhagVaz1eXGTeJ90nsXP1g9hg1QXMZ=s497-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipOovQykLjwvUy6LG_sPcVLtL_ta2bLpTeHNuz2R=s435-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipOVZ96DC5Bqfb7fgDpywLQI5ZmtZpsH-Wk1byDz=s437-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipMy4Vi3OcV4t4qJKz_UmjvmCaDS2sKqPzN3UqOC=s435-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipNHZJDztNi9GpEzu_GOHBW8B4PLJ0VtFssYGhJE=s387-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipOyTG3JNBOcYPz-4g5Y2pz8fCBD_4snkr1yA8Iq=s435-k-no',
                'https://lh5.googleusercontent.com/p/AF1QipP4jFrppfHTuVcxkM-8qtxD6jhaE1wcmZp5jvxn=s387-k-no',
                'https://s3-media0.fl.yelpcdn.com/bphoto/D1iKzDXv6h79LtABr43Oig/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/7NMSQ5ZiZ2JhAagYX6T-pg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/DQCfvvDjueUFNKecYWBoQw/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/dvLz844-KRs9P8mmQ0YdfA/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/g1YZWRfjUFht2RPG_iLVkg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/qtNLNeTGxKFsUC1FtZ9yvA/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/JxMHxGfsRjTVRWL3X0KJrg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/6AAHfgq7H85rSjp4azfK0Q/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/SHrhYTfieFOKrHlU9SBzVQ/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/w-QObZl24EuZbv6oHSw_Pg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/LrenQBIiSEAC6mByqFPefg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/UDMwnX2aiETlERXQMkW05Q/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/J2-Rbq_YYq0RtAOZhOKaJg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/6DI09CyComx5_V30JcO_MA/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/dzeCPmVi06lfJ645VW5o5Q/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/0q2vk4gk0GsojAcxcKeOtw/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/sZX57ewdJnGBZQdrPqPTLQ/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/Yl_7mAejrYkc1sbPI01eqg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/zdno5tlnhDRmoAvXcZNQ6A/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/55dH7Uw1Q_pYT7mDQ7cBfQ/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/KucFLcBLkSIL3aJXpqoOyw/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/FljsIXScPCYUvVeXBeraGw/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/sX79_uhG1UhWcFdkCKYnoQ/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/iSBhjOJiFj4PWQB6OEdgqg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/VgZCBELF-0t2nNFiGY4Vnw/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/D1DutcOse3tmrKQf_b_BnA/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/QsZniGL4PJRMvhgDTZhoxw/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/hlHcSvGrFKQLS0sazNqv-A/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/2w-LrFI83aqQfmhLAVCalg/o.jpg',
                'https://s3-media0.fl.yelpcdn.com/bphoto/1y0mCNofIitJbVl0XZQb7g/o.jpg',
            ],
        },
        listings: {
            grade: 'A',
            listingsAccuracyTotalPercentage: 96.03,
            listingsFoundOverview: {
                foundListings: 3,
                availableListings: 48,
                listingsWithErrors: 1,
            },
            listingsAccuracyOverview: {
                businessNamePercentage: 100,
                addressPercentage: 100,
                phoneNumberPercentage: 88.1,
            },
            data: [
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-6.png',
                    siteName: 'MerchantCircle',
                    url: 'http://merchantcircle.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-7.png',
                    siteName: 'Citysearch',
                    url: 'http://citysearch.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-9.png',
                    siteName: 'MapQuest',
                    url: 'http://mapquest.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-15.png',
                    siteName: 'Yelp',
                    url: 'https://www.yelp.com/biz/roto-rooter-plumbing-and-water-cleanup-doral?adjust_creative=MFyzcjahxBMNAyHg85HGjg&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_lookup&utm_source=MFyzcjahxBMNAyHg85HGjg',
                    name: {
                        score: 1,
                        value: 'Roto-Rooter Plumbing & Water Cleanup',
                    },
                    address: {
                        score: 1,
                        value: '7847 NW 15th St',
                    },
                    city: 'Doral',
                    state: 'FL',
                    country: 'US',
                    zip: '33126',
                    phone: {
                        score: 0.64,
                        value: '+13057140028',
                    },
                    has_hours: true,
                    status: 'LISTING_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-19.png',
                    siteName: 'Yahoo!',
                    url: 'http://local.yahoo.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-23.png',
                    siteName: 'ShowMeLocal',
                    url: 'http://showmelocal.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-24.png',
                    siteName: 'Bing',
                    url: 'http://bing.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-30.png',
                    siteName: 'Tupalo',
                    url: 'http://tupalo.co',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-32.png',
                    siteName: 'YellowMoxie',
                    url: 'http://yellowmoxie.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-39.png',
                    siteName: 'LocalPages',
                    url: 'http://localpages.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-43.png',
                    siteName: 'Where To?',
                    url: 'https://wheretoapp.com/search?poi=11740237172821251556',
                    name: {
                        score: 1,
                        value: 'Roto-Rooter Plumbing & Water Cleanup',
                    },
                    address: {
                        score: 1,
                        value: '7847 NW 15th St',
                    },
                    city: 'Doral',
                    state: 'FL',
                    country: 'US',
                    zip: '33126',
                    phone: {
                        score: 1,
                        value: '+1 305-521-0281',
                    },
                    has_hours: true,
                    status: 'LISTING_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-44.png',
                    siteName: 'CitySquares',
                    url: 'http://citysquares.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-47.png',
                    siteName: 'Navmii',
                    url: 'http://navmii.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-57.png',
                    siteName: 'USCity.net',
                    url: 'http://uscity.net',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-58.png',
                    siteName: 'YellowPageCity.com',
                    url: 'http://yellowpagecity.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-59.png',
                    siteName: 'ChamberofCommerce.com',
                    url: 'http://chamberofcommerce.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-60.png',
                    siteName: '8coupons',
                    url: 'http://8coupons.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-63.png',
                    siteName: 'AmericanTowns.com',
                    url: 'http://americantowns.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-64.png',
                    siteName: 'eLocal',
                    url: 'http://elocal.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-65.png',
                    siteName: 'YP.com',
                    url: 'http://yellowpages.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-71.png',
                    siteName: 'Facebook',
                    url: 'http://facebook.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-74.png',
                    siteName: 'YaSabe',
                    url: 'http://yasabe.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-75.png',
                    siteName: 'GoLocal247',
                    url: 'http://golocal247.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-81.png',
                    siteName: 'YellowPagesDirectory',
                    url: 'http://YellowPagesDirectory.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-83.png',
                    siteName: 'Pointcom',
                    url: 'http://pointcom.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-84.png',
                    siteName: 'ABLocal',
                    url: 'http://ablocal.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-86.png',
                    siteName: 'Opendi',
                    url: 'http://opendi.us',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-87.png',
                    siteName: 'VotefortheBest',
                    url: 'http://voteforthebest.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-89.png',
                    siteName: '2findlocal',
                    url: 'http://2findlocal.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-95.png',
                    siteName: 'My Local Services',
                    url: 'http://mylocalservices.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-100.png',
                    siteName: 'n49',
                    url: 'http://n49.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-135.png',
                    siteName: 'Cylex',
                    url: 'http://cylex-usa.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-163.png',
                    siteName: 'iBegin',
                    url: 'http://ibegin.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-159.png',
                    siteName: 'iGlobal',
                    url: 'http://iglobal.co',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-187.png',
                    siteName: 'Insider Pages',
                    url: 'http://insiderpages.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-184.png',
                    siteName: 'LocalStack',
                    url: 'http://localstack.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-209.png',
                    siteName: 'Yalwa',
                    url: 'http://yalwa.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-214.png',
                    siteName: 'Brownbook.net',
                    url: 'http://brownbook.net',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-247.png',
                    siteName: 'Google Places',
                    url: 'https://maps.google.com/?cid=11740237172821251556',
                    name: {
                        score: 1,
                        value: 'Roto-Rooter Plumbing & Water Cleanup',
                    },
                    address: {
                        score: 1,
                        value: '7847 NW 15th St',
                    },
                    city: 'Doral',
                    state: 'FL',
                    country: 'US',
                    zip: '33126',
                    phone: {
                        score: 1,
                        value: '(305) 521-0281',
                    },
                    has_hours: true,
                    status: 'LISTING_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-251.png',
                    siteName: 'AroundMe',
                    url: '',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-258.png',
                    siteName: 'HotFrog',
                    url: 'http://hotfrog.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-272.png',
                    siteName: 'EZlocal',
                    url: 'http://ezlocal.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-304.png',
                    siteName: 'LocalDatabase',
                    url: '',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-311.png',
                    siteName: 'Find Open',
                    url: 'https://find-open.com/',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-369.png',
                    siteName: 'Property Capsule',
                    url: '',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-370.png',
                    siteName: 'Local.com v2',
                    url: '',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-415.png',
                    siteName: 'Mafengwo',
                    url: 'http://mafengwo.cn',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-416.png',
                    siteName: 'Top Rated Local',
                    url: '',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-423.png',
                    siteName: 'RetirementPlanning.net',
                    url: 'https://www.retirementplanning.net/',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-427.png',
                    siteName: 'HostMe',
                    url: 'http://tables.hostmeapp.com',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-443.png',
                    siteName: 'tellows',
                    url: 'http://tellows.de',
                    status: 'LISTING_NOT_FOUND',
                },
                {
                    logoURL: 'https://www.yext-static.com/cms/spark/1/site-icon-medium-466.png',
                    siteName: 'NDrive',
                    url: 'https://ndrive.com/',
                    status: 'LISTING_NOT_FOUND',
                },
            ],
        },
        reviews: {
            grade: 'F',
            totalOnlineReviews: {
                reviewsFound: {
                    text: 'Google: 478 | Yelp: 66',
                    totalReviews: 544,
                    industryAvg: 0,
                },
                reviewsFoundLastSix: {
                    totalLastSixMonths: 135,
                    industryAvg: 0,
                },
                averageReviewScore: {
                    yourRating: 4.2,
                    industryAvg: 4.13,
                },
                sourcesForReviews: {
                    yourRating: 2,
                    industryAvg: 0,
                },
                reviews: [
                    {
                        image: 'https://lh3.googleusercontent.com/a/AATXAJwp2bXY0t26fSFsPMT6HdlwtUkpF1xQ27z3czg=w36-h36-p-c0x00000000-rp-mo-br100',
                        name: 'Roberto Madruga',
                        date: 'a week ago',
                        stars: 5,
                        content:
                            'Michael was excellent very professional and fixed the problem with expertise. I highly recommend this company and Michael.',
                        type: 'google',
                    },
                    {
                        image: 'https://s3-media0.fl.yelpcdn.com/photo/kdVF23i5d2IugZyl1gaRXA/60s.jpg',
                        name: 'Anabel S.',
                        date: '4/6/2021',
                        stars: 1,
                        content:
                            'I chose this company despite it being very expensive because they will come out the same day and guarantee for 6 months that if the issue persists, they will come again. Well I had the issue again and I called them to come out and they said they were "backed up" and couldn\'t get anyone until the next day. Mind you, my house is flooded with water. Terrible service from the company.',
                        type: 'yelp',
                    },
                ],
            },
            googleReviews: {
                totalReview: 478,
                lastSixMonthReviewsCount: 133,
                avgReviewScore: 4.9,
                reviewPageURL:
                    'https://www.google.com/maps/place/Roto-Rooter+Plumbing+%26+Water+Cleanup/@25.7894671,-80.322112,17z/data=!4m16!1m8!3m7!1s0x0:0xa2edb38198d8d5e4!2sRoto-Rooter+Plumbing+%26+Water+Cleanup!8m2!3d25.7894671!4d-80.322112!14m1!1BCgIgAQ!3m6!1s0x0:0xa2edb38198d8d5e4!8m2!3d25.7894671!4d-80.322112!9m1!1b1?hl=en',
                lastreview: {
                    image: 'https://lh3.googleusercontent.com/a-/AOh14GgFQ4yw5KQuOch1vZxLBSnhFwjXKi8j8KFl4Z6Ot5g=w36-h36-p-c0x00000000-rp-mo-br100',
                    name: 'MARGARITA RAMIREZ',
                    date: 'a week ago',
                    stars: 5,
                    content: '',
                },
            },
            yelpReviews: {
                totalReview: 66,
                lastSixMonthReviewsCount: 2,
                avgReviewScore: 3.5,
                reviewPageURL:
                    'https://www.yelp.com/biz/roto-rooter-plumbing-and-water-cleanup-doral',
                lastreview: {
                    image: 'https://s3-media0.fl.yelpcdn.com/photo/NznHZF7j7qfUr_5muTRI2w/60s.jpg',
                    name: 'Hans P.',
                    date: '3/4/2021',
                    stars: 4,
                    content:
                        'Professional, courteous, and quick. All necessary masks, gloves, etc worn. Would recommend',
                },
            },
            facebookReviews: {},
        },
        social: {
            grade: 'B',
            facebook: {
                likes: {
                    totalLikes: 111,
                    industryAverage: 222,
                    industryLeaders: 333,
                },
                averagePostsPerMonth: {
                    avgposts: 444,
                    industryAverage: 555,
                    industryLeaders: 666,
                },
                averageLikesPerPost: {
                    averageLikes: 777,
                    industryAverage: 888,
                    industryLeaders: 999,
                },
                averageSharesPerPost: {
                    averageShare: 11,
                    industryAverage: 22,
                    industryLeaders: 33,
                },
            },
        },
        website: {
            grade: 'A',
            desktop: {
                grade: 'B',
                screenshot:
                    'data:image/jpeg;base64,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',
                passed: {
                    length: 32,
                    data: [
                        {
                            id: 'legacy-javascript',
                            title: 'Avoid serving legacy JavaScript to modern browsers',
                            description:
                                "Polyfills and transforms enable legacy browsers to use new JavaScript features. However, many aren't necessary for modern browsers. For your bundled JavaScript, adopt a modern script deployment strategy using module/nomodule feature detection to reduce the amount of code shipped to modern browsers, while retaining support for legacy browsers. [Learn More](https://philipwalton.com/articles/deploying-es2015-code-in-production-today/)",
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 0 KiB',
                            details: {
                                overallSavingsBytes: 45,
                                headings: [
                                    {
                                        key: 'url',
                                        valueType: 'url',
                                        subItemsHeading: {
                                            valueType: 'source-location',
                                            key: 'location',
                                        },
                                        label: 'URL',
                                    },
                                    {
                                        key: null,
                                        valueType: 'code',
                                        subItemsHeading: {
                                            key: 'signal',
                                        },
                                    },
                                    {
                                        key: 'wastedBytes',
                                        valueType: 'bytes',
                                        label: 'Potential Savings',
                                    },
                                ],
                                overallSavingsMs: 0,
                                items: [
                                    {
                                        totalBytes: 0,
                                        wastedBytes: 45,
                                        url: 'https://www.rotorooter.com/vendor-es2015.536e6f78051d9ce391bc.js',
                                        subItems: {
                                            type: 'subitems',
                                            items: [
                                                {
                                                    location: {
                                                        line: 0,
                                                        column: 347555,
                                                        url: 'https://www.rotorooter.com/vendor-es2015.536e6f78051d9ce391bc.js',
                                                        urlProvider: 'network',
                                                        type: 'source-location',
                                                    },
                                                    signal: '@babel/plugin-transform-classes',
                                                },
                                            ],
                                        },
                                    },
                                ],
                                type: 'opportunity',
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'offscreen-images',
                            title: 'Defer offscreen images',
                            description:
                                'Consider lazy-loading offscreen and hidden images after all critical resources have finished loading to lower time to interactive. [Learn more](https://web.dev/offscreen-images/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                items: [],
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                                headings: [],
                                overallSavingsMs: 0,
                            },
                            warnings: [],
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'first-meaningful-paint',
                            title: 'First Meaningful Paint',
                            description:
                                'First Meaningful Paint measures when the primary content of a page is visible. [Learn more](https://web.dev/first-meaningful-paint/).',
                            score: 0.97,
                            scoreDisplayMode: 'numeric',
                            displayValue: '0.7 s',
                            numericValue: 740,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-rel-preconnect',
                            title: 'Preconnect to required origins',
                            description:
                                'Consider adding `preconnect` or `dns-prefetch` resource hints to establish early connections to important third-party origins. [Learn more](https://web.dev/uses-rel-preconnect/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            warnings: [
                                'A `<link rel=preconnect>` was found for "https://rotorooterinc.tt.omtrdc.net" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'A `<link rel=preconnect>` was found for "https://www.googletagmanager.com" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'A `<link rel=preconnect>` was found for "https://www.google-analytics.com" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'A `<link rel=preconnect>` was found for "https://www.google.com" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'A `<link rel=preconnect>` was found for "https://stats.g.doubleclick.net" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'More than 2 `<link rel=preconnect>` connections were found. These should be used sparingly and only to the most important origins.',
                            ],
                        },
                        {
                            id: 'unused-javascript',
                            title: 'Reduce unused JavaScript',
                            description:
                                'Reduce unused JavaScript and defer loading scripts until they are required to decrease bytes consumed by network activity. [Learn more](https://web.dev/unused-javascript/).',
                            score: 0.9,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 127 KiB',
                            details: {
                                overallSavingsMs: 120,
                                overallSavingsBytes: 130353,
                                headings: [
                                    {
                                        valueType: 'url',
                                        label: 'URL',
                                        key: 'url',
                                        subItemsHeading: {
                                            key: 'source',
                                            valueType: 'code',
                                        },
                                    },
                                    {
                                        key: 'totalBytes',
                                        subItemsHeading: {
                                            key: 'sourceBytes',
                                        },
                                        label: 'Transfer Size',
                                        valueType: 'bytes',
                                    },
                                    {
                                        key: 'wastedBytes',
                                        label: 'Potential Savings',
                                        subItemsHeading: {
                                            key: 'sourceWastedBytes',
                                        },
                                        valueType: 'bytes',
                                    },
                                ],
                                type: 'opportunity',
                                items: [
                                    {
                                        totalBytes: 216938,
                                        wastedBytes: 106063,
                                        url: 'https://www.rotorooter.com/vendor-es2015.536e6f78051d9ce391bc.js',
                                        wastedPercent: 48.89106210077057,
                                    },
                                    {
                                        totalBytes: 111007,
                                        wastedPercent: 21.881565321889877,
                                        wastedBytes: 24290,
                                        url: 'https://www.rotorooter.com/main-es2015.201ea8f097437a77e69f.js',
                                    },
                                ],
                            },
                            numericValue: 120,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-long-cache-ttl',
                            title: 'Uses efficient cache policy on static assets',
                            description:
                                'A long cache lifetime can speed up repeat visits to your page. [Learn more](https://web.dev/uses-long-cache-ttl/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: '0 resources found',
                            details: {
                                summary: {
                                    wastedBytes: 0,
                                },
                                items: [],
                                type: 'table',
                                headings: [],
                            },
                            numericValue: 0,
                            numericUnit: 'byte',
                        },
                        {
                            id: 'no-document-write',
                            title: 'Avoids `document.write()`',
                            description:
                                'For users on slow connections, external scripts dynamically injected via `document.write()` can delay page load by tens of seconds. [Learn more](https://web.dev/no-document-write/).',
                            score: 1,
                            scoreDisplayMode: 'binary',
                            details: {
                                items: [],
                                type: 'table',
                                headings: [],
                            },
                        },
                        {
                            id: 'cumulative-layout-shift',
                            title: 'Cumulative Layout Shift',
                            description:
                                'Cumulative Layout Shift measures the movement of visible elements within the viewport. [Learn more](https://web.dev/cls/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: '0.014',
                            details: {
                                items: [
                                    {
                                        totalCumulativeLayoutShift: 0.014492695254356012,
                                        cumulativeLayoutShiftMainFrame: 0.014492695254356012,
                                    },
                                ],
                                type: 'debugdata',
                            },
                            numericValue: 0.014492695254356012,
                            numericUnit: 'unitless',
                        },
                        {
                            id: 'uses-responsive-images',
                            title: 'Properly size images',
                            description:
                                'Serve images that are appropriately-sized to save cellular data and improve load time. [Learn more](https://web.dev/uses-responsive-images/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 9 KiB',
                            details: {
                                overallSavingsMs: 0,
                                headings: [
                                    {
                                        key: 'url',
                                        valueType: 'thumbnail',
                                    },
                                    {
                                        valueType: 'url',
                                        key: 'url',
                                        label: 'URL',
                                    },
                                    {
                                        key: 'totalBytes',
                                        valueType: 'bytes',
                                        label: 'Resource Size',
                                    },
                                    {
                                        key: 'wastedBytes',
                                        valueType: 'bytes',
                                        label: 'Potential Savings',
                                    },
                                ],
                                items: [
                                    {
                                        wastedBytes: 9057,
                                        url: 'https://cdn.rotorootercdn.com/images/images/home/hero_image.png',
                                        wastedPercent: 10.460078399009697,
                                        totalBytes: 86585,
                                    },
                                ],
                                overallSavingsBytes: 9057,
                                type: 'opportunity',
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'speed-index',
                            title: 'Speed Index',
                            description:
                                'Speed Index shows how quickly the contents of a page are visibly populated. [Learn more](https://web.dev/speed-index/).',
                            score: 0.98,
                            scoreDisplayMode: 'numeric',
                            displayValue: '1.0 s',
                            numericValue: 960.4639667848746,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-passive-event-listeners',
                            title: 'Uses passive listeners to improve scrolling performance',
                            description:
                                "Consider marking your touch and wheel event listeners as `passive` to improve your page's scroll performance. [Learn more](https://web.dev/uses-passive-event-listeners/).",
                            score: 1,
                            scoreDisplayMode: 'binary',
                            details: {
                                headings: [],
                                type: 'table',
                                items: [],
                            },
                        },
                        {
                            id: 'total-byte-weight',
                            title: 'Avoids enormous network payloads',
                            description:
                                'Large network payloads cost users real money and are highly correlated with long load times. [Learn more](https://web.dev/total-byte-weight/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Total size was 546 KiB',
                            details: {
                                headings: [
                                    {
                                        text: 'URL',
                                        key: 'url',
                                        itemType: 'url',
                                    },
                                    {
                                        text: 'Transfer Size',
                                        key: 'totalBytes',
                                        itemType: 'bytes',
                                    },
                                ],
                                type: 'table',
                                items: [
                                    {
                                        url: 'https://www.rotorooter.com/vendor-es2015.536e6f78051d9ce391bc.js',
                                        totalBytes: 216938,
                                    },
                                    {
                                        url: 'https://www.rotorooter.com/main-es2015.201ea8f097437a77e69f.js',
                                        totalBytes: 111007,
                                    },
                                    {
                                        url: 'https://cdn.rotorootercdn.com/images/images/home/hero_image.png',
                                        totalBytes: 87057,
                                    },
                                    {
                                        totalBytes: 48193,
                                        url: 'https://www.rotorooter.com/',
                                    },
                                    {
                                        totalBytes: 18582,
                                        url: 'https://use.typekit.net/af/cfbead/0000000000000000000146b3/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                    },
                                    {
                                        totalBytes: 16862,
                                        url: 'https://use.typekit.net/af/46da36/00000000000000003b9acaf6/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                    },
                                    {
                                        url: 'https://use.typekit.net/af/6d4bb2/00000000000000003b9acafc/27/l?fvd=n7&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                        totalBytes: 16570,
                                    },
                                    {
                                        url: 'https://www.rotorooter.com/polyfills-es2015.4d4244071d265f56206f.js',
                                        totalBytes: 12830,
                                    },
                                    {
                                        url: 'https://www.rotorooter.com/styles.4fe6d142c78b045262be.css',
                                        totalBytes: 10468,
                                    },
                                    {
                                        totalBytes: 4469,
                                        url: 'https://cdn.rotorootercdn.com/images/images/home/plumbingdrain.svg',
                                    },
                                ],
                            },
                            numericValue: 559295,
                            numericUnit: 'byte',
                        },
                        {
                            id: 'bootup-time',
                            title: 'JavaScript execution time',
                            description:
                                'Consider reducing the time spent parsing, compiling, and executing JS. You may find delivering smaller JS payloads helps with this. [Learn more](https://web.dev/bootup-time/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: '0.4 s',
                            details: {
                                summary: {
                                    wastedMs: 351.46799999999956,
                                },
                                type: 'table',
                                items: [
                                    {
                                        scripting: 314.9529999999996,
                                        scriptParseCompile: 0.23099999999999998,
                                        total: 327.95999999999964,
                                        url: 'https://www.rotorooter.com/polyfills-es2015.4d4244071d265f56206f.js',
                                    },
                                    {
                                        scripting: 1.633,
                                        total: 140.18499999999997,
                                        scriptParseCompile: 0.8440000000000001,
                                        url: 'https://www.rotorooter.com/',
                                    },
                                    {
                                        url: 'Unattributable',
                                        scriptParseCompile: 0.24400000000000002,
                                        total: 82.24099999999994,
                                        scripting: 33.562999999999995,
                                    },
                                ],
                                headings: [
                                    {
                                        key: 'url',
                                        text: 'URL',
                                        itemType: 'url',
                                    },
                                    {
                                        itemType: 'ms',
                                        text: 'Total CPU Time',
                                        granularity: 1,
                                        key: 'total',
                                    },
                                    {
                                        key: 'scripting',
                                        granularity: 1,
                                        itemType: 'ms',
                                        text: 'Script Evaluation',
                                    },
                                    {
                                        itemType: 'ms',
                                        granularity: 1,
                                        key: 'scriptParseCompile',
                                        text: 'Script Parse',
                                    },
                                ],
                            },
                            numericValue: 351.46799999999956,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'unused-css-rules',
                            title: 'Reduce unused CSS',
                            description:
                                'Reduce unused rules from stylesheets and defer CSS not used for above-the-fold content to decrease bytes consumed by network activity. [Learn more](https://web.dev/unused-css-rules/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                overallSavingsMs: 0,
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                                headings: [],
                                items: [],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-rel-preload',
                            title: 'Preload key requests',
                            description:
                                'Consider using `<link rel=preload>` to prioritize fetching resources that are currently requested later in page load. [Learn more](https://web.dev/uses-rel-preload/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                headings: [],
                                type: 'opportunity',
                                items: [],
                                overallSavingsMs: 0,
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'mainthread-work-breakdown',
                            title: 'Minimizes main-thread work',
                            description:
                                'Consider reducing the time spent parsing, compiling and executing JS. You may find delivering smaller JS payloads helps with this. [Learn more](https://web.dev/mainthread-work-breakdown/)',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: '0.6 s',
                            details: {
                                type: 'table',
                                headings: [
                                    {
                                        itemType: 'text',
                                        text: 'Category',
                                        key: 'groupLabel',
                                    },
                                    {
                                        itemType: 'ms',
                                        granularity: 1,
                                        text: 'Time Spent',
                                        key: 'duration',
                                    },
                                ],
                                items: [
                                    {
                                        duration: 350.14899999999955,
                                        group: 'scriptEvaluation',
                                        groupLabel: 'Script Evaluation',
                                    },
                                    {
                                        duration: 84.287,
                                        group: 'styleLayout',
                                        groupLabel: 'Style & Layout',
                                    },
                                    {
                                        groupLabel: 'Other',
                                        duration: 74.91100000000002,
                                        group: 'other',
                                    },
                                    {
                                        duration: 27.42999999999999,
                                        group: 'paintCompositeRender',
                                        groupLabel: 'Rendering',
                                    },
                                    {
                                        group: 'parseHTML',
                                        groupLabel: 'Parse HTML & CSS',
                                        duration: 16.177,
                                    },
                                    {
                                        group: 'scriptParseCompile',
                                        groupLabel: 'Script Parsing & Compilation',
                                        duration: 7.8790000000000004,
                                    },
                                    {
                                        group: 'garbageCollection',
                                        groupLabel: 'Garbage Collection',
                                        duration: 7.131,
                                    },
                                ],
                            },
                            numericValue: 567.9639999999995,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'server-response-time',
                            title: 'Initial server response time was short',
                            description:
                                'Keep the server response time for the main document short because all other requests depend on it. [Learn more](https://web.dev/time-to-first-byte/).',
                            score: 1,
                            scoreDisplayMode: 'binary',
                            displayValue: 'Root document took 460 ms',
                            details: {
                                type: 'opportunity',
                                items: [
                                    {
                                        url: 'https://www.rotorooter.com/',
                                        responseTime: 459.529,
                                    },
                                ],
                                overallSavingsMs: 359.529,
                                headings: [
                                    {
                                        key: 'url',
                                        label: 'URL',
                                        valueType: 'url',
                                    },
                                    {
                                        key: 'responseTime',
                                        valueType: 'timespanMs',
                                        label: 'Time Spent',
                                    },
                                ],
                            },
                            numericValue: 459.529,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'unminified-javascript',
                            title: 'Minify JavaScript',
                            description:
                                'Minifying JavaScript files can reduce payload sizes and script parse time. [Learn more](https://web.dev/unminified-javascript/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 2 KiB',
                            details: {
                                overallSavingsMs: 0,
                                headings: [
                                    {
                                        key: 'url',
                                        label: 'URL',
                                        valueType: 'url',
                                    },
                                    {
                                        key: 'totalBytes',
                                        label: 'Transfer Size',
                                        valueType: 'bytes',
                                    },
                                    {
                                        valueType: 'bytes',
                                        key: 'wastedBytes',
                                        label: 'Potential Savings',
                                    },
                                ],
                                overallSavingsBytes: 2176,
                                type: 'opportunity',
                                items: [
                                    {
                                        wastedPercent: 91.65870188548094,
                                        totalBytes: 2374,
                                        url: 'inline: {&q;itemListing-&q;:{&q;data&q;:{&q;getR...',
                                        wastedBytes: 2176,
                                    },
                                ],
                            },
                            warnings: [],
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'third-party-summary',
                            title: 'Minimize third-party usage',
                            description:
                                'Third-party code can significantly impact load performance. Limit the number of redundant third-party providers and try to load third-party code after your page has primarily finished loading. [Learn more](https://developers.google.com/web/fundamentals/performance/optimizing-content-efficiency/loading-third-party-javascript/).',
                            score: 1,
                            scoreDisplayMode: 'binary',
                            displayValue: 'Third-party code blocked the main thread for 0 ms',
                            details: {
                                type: 'table',
                                items: [
                                    {
                                        entity: {
                                            url: 'https://fonts.adobe.com/',
                                            text: 'Adobe TypeKit',
                                            type: 'link',
                                        },
                                        transferSize: 52014,
                                        subItems: {
                                            items: [
                                                {
                                                    blockingTime: 0,
                                                    transferSize: 18582,
                                                    url: 'https://use.typekit.net/af/cfbead/0000000000000000000146b3/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                                    mainThreadTime: 0,
                                                },
                                                {
                                                    mainThreadTime: 0,
                                                    blockingTime: 0,
                                                    url: 'https://use.typekit.net/af/46da36/00000000000000003b9acaf6/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                                    transferSize: 16862,
                                                },
                                                {
                                                    blockingTime: 0,
                                                    mainThreadTime: 0,
                                                    url: 'https://use.typekit.net/af/6d4bb2/00000000000000003b9acafc/27/l?fvd=n7&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                                    transferSize: 16570,
                                                },
                                            ],
                                            type: 'subitems',
                                        },
                                        mainThreadTime: 0,
                                        blockingTime: 0,
                                    },
                                ],
                                summary: {
                                    wastedBytes: 52014,
                                    wastedMs: 0,
                                },
                                headings: [
                                    {
                                        key: 'entity',
                                        text: 'Third-Party',
                                        subItemsHeading: {
                                            key: 'url',
                                            itemType: 'url',
                                        },
                                        itemType: 'link',
                                    },
                                    {
                                        granularity: 1,
                                        key: 'transferSize',
                                        subItemsHeading: {
                                            key: 'transferSize',
                                        },
                                        text: 'Transfer Size',
                                        itemType: 'bytes',
                                    },
                                    {
                                        text: 'Main-Thread Blocking Time',
                                        key: 'blockingTime',
                                        itemType: 'ms',
                                        granularity: 1,
                                        subItemsHeading: {
                                            key: 'blockingTime',
                                        },
                                    },
                                ],
                            },
                        },
                        {
                            id: 'dom-size',
                            title: 'Avoids an excessive DOM size',
                            description:
                                'A large DOM will increase memory usage, cause longer [style calculations](https://developers.google.com/web/fundamentals/performance/rendering/reduce-the-scope-and-complexity-of-style-calculations), and produce costly [layout reflows](https://developers.google.com/speed/articles/reflow). [Learn more](https://web.dev/dom-size/).',
                            score: 0.96,
                            scoreDisplayMode: 'numeric',
                            displayValue: '679 elements',
                            details: {
                                headings: [
                                    {
                                        text: 'Statistic',
                                        key: 'statistic',
                                        itemType: 'text',
                                    },
                                    {
                                        key: 'node',
                                        text: 'Element',
                                        itemType: 'node',
                                    },
                                    {
                                        itemType: 'numeric',
                                        text: 'Value',
                                        key: 'value',
                                    },
                                ],
                                type: 'table',
                                items: [
                                    {
                                        value: 679,
                                        statistic: 'Total DOM Elements',
                                    },
                                    {
                                        value: 18,
                                        node: {
                                            lhId: '6-49-path',
                                            selector:
                                                'div.flypInputWrap > a.fylpBtn > svg.header-fylp-btn > path',
                                            boundingRect: {
                                                left: 1163,
                                                bottom: 524,
                                                top: 503,
                                                width: 13,
                                                height: 21,
                                                right: 1176,
                                            },
                                            path: '1,HTML,1,BODY,0,APP-ROOT,1,DIV,1,APP-HOME,0,APP-PRIMARY-BANNER,0,DIV,0,DIV,0,DIV,1,DIV,4,DIV,2,DIV,0,APP-FYLP,0,DIV,0,DIV,2,DIV,1,A,0,svg,0,path',
                                            type: 'node',
                                            snippet:
                                                '<path _ngcontent-app-c16="" d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z" fill="#fff">',
                                            nodeLabel: 'path',
                                        },
                                        statistic: 'Maximum DOM Depth',
                                    },
                                    {
                                        node: {
                                            type: 'node',
                                            boundingRect: {
                                                width: 289,
                                                left: 71,
                                                right: 361,
                                                top: 90,
                                                bottom: 107,
                                                height: 17,
                                            },
                                            selector: 'div.desktop-logo > a > svg.svg-logo > g',
                                            path: '1,HTML,1,BODY,0,APP-ROOT,0,APP-HEADER,1,HEADER,0,DIV,1,DIV,0,DIV,0,DIV,0,DIV,0,DIV,0,A,0,svg,3,g',
                                            snippet: '<g>',
                                            lhId: '6-50-g',
                                            nodeLabel: 'g',
                                        },
                                        value: 25,
                                        statistic: 'Maximum Child Elements',
                                    },
                                ],
                            },
                            numericValue: 679,
                            numericUnit: 'element',
                        },
                        {
                            id: 'efficient-animated-content',
                            title: 'Use video formats for animated content',
                            description:
                                'Large GIFs are inefficient for delivering animated content. Consider using MPEG4/WebM videos for animations and PNG/WebP for static images instead of GIF to save network bytes. [Learn more](https://web.dev/efficient-animated-content/)',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                overallSavingsMs: 0,
                                headings: [],
                                items: [],
                                type: 'opportunity',
                                overallSavingsBytes: 0,
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'total-blocking-time',
                            title: 'Total Blocking Time',
                            description:
                                'Sum of all time periods between FCP and Time to Interactive, when task length exceeded 50ms, expressed in milliseconds. [Learn more](https://web.dev/lighthouse-total-blocking-time/).',
                            score: 0.99,
                            scoreDisplayMode: 'numeric',
                            displayValue: '70 ms',
                            numericValue: 69,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'unminified-css',
                            title: 'Minify CSS',
                            description:
                                'Minifying CSS files can reduce network payload sizes. [Learn more](https://web.dev/unminified-css/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                overallSavingsMs: 0,
                                headings: [],
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                                items: [],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'unsized-images',
                            title: 'Image elements have explicit `width` and `height`',
                            description:
                                'Set an explicit width and height on image elements to reduce layout shifts and improve CLS. [Learn more](https://web.dev/optimize-cls/#images-without-dimensions)',
                            score: 1,
                            scoreDisplayMode: 'binary',
                            details: {
                                type: 'table',
                                headings: [],
                                items: [],
                            },
                        },
                        {
                            id: 'redirects',
                            title: 'Avoid multiple page redirects',
                            description:
                                'Redirects introduce additional delays before the page can be loaded. [Learn more](https://web.dev/redirects/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                type: 'opportunity',
                                headings: [],
                                overallSavingsMs: 0,
                                items: [],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'duplicated-javascript',
                            title: 'Remove duplicate modules in JavaScript bundles',
                            description:
                                'Remove large, duplicate JavaScript modules from bundles to reduce unnecessary bytes consumed by network activity. ',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                type: 'opportunity',
                                items: [],
                                overallSavingsMs: 0,
                                headings: [],
                                overallSavingsBytes: 0,
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-optimized-images',
                            title: 'Efficiently encode images',
                            description:
                                'Optimized images load faster and consume less cellular data. [Learn more](https://web.dev/uses-optimized-images/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                type: 'opportunity',
                                items: [],
                                overallSavingsMs: 0,
                                headings: [],
                                overallSavingsBytes: 0,
                            },
                            warnings: [],
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'modern-image-formats',
                            title: 'Serve images in next-gen formats',
                            description:
                                'Image formats like JPEG 2000, JPEG XR, and WebP often provide better compression than PNG or JPEG, which means faster downloads and less data consumption. [Learn more](https://web.dev/uses-webp-images/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                type: 'opportunity',
                                overallSavingsBytes: 0,
                                headings: [],
                                overallSavingsMs: 0,
                                items: [],
                            },
                            warnings: [],
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'interactive',
                            title: 'Time to Interactive',
                            description:
                                'Time to interactive is the amount of time it takes for the page to become fully interactive. [Learn more](https://web.dev/interactive/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: '1.1 s',
                            numericValue: 1084,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'first-contentful-paint',
                            title: 'First Contentful Paint',
                            description:
                                'First Contentful Paint marks the time at which the first text or image is painted. [Learn more](https://web.dev/first-contentful-paint/).',
                            score: 0.97,
                            scoreDisplayMode: 'numeric',
                            displayValue: '0.7 s',
                            numericValue: 740,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'preload-lcp-image',
                            title: 'Preload Largest Contentful Paint image',
                            description:
                                'Preload the image used by the LCP element in order to improve your LCP time. [Learn more](https://web.dev/optimize-lcp/#preload-important-resources).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                type: 'opportunity',
                                items: [
                                    {
                                        wastedMs: 0,
                                        url: 'https://cdn.rotorootercdn.com/images/images/home/hero_image.png',
                                    },
                                ],
                                overallSavingsMs: 0,
                                headings: [
                                    {
                                        valueType: 'thumbnail',
                                        key: 'url',
                                    },
                                    {
                                        key: 'url',
                                        valueType: 'url',
                                        label: 'URL',
                                    },
                                    {
                                        label: 'Potential Savings',
                                        valueType: 'timespanMs',
                                        key: 'wastedMs',
                                    },
                                ],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-text-compression',
                            title: 'Enable text compression',
                            description:
                                'Text-based resources should be served with compression (gzip, deflate or brotli) to minimize total network bytes. [Learn more](https://web.dev/uses-text-compression/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                overallSavingsBytes: 0,
                                overallSavingsMs: 0,
                                headings: [],
                                items: [],
                                type: 'opportunity',
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                    ],
                },
                considerFixing: {
                    length: 3,
                    data: [
                        {
                            id: 'max-potential-fid',
                            title: 'Max Potential First Input Delay',
                            description:
                                'The maximum potential First Input Delay that your users could experience is the duration of the longest task. [Learn more](https://web.dev/lighthouse-max-potential-fid/).',
                            score: 0.81,
                            scoreDisplayMode: 'numeric',
                            displayValue: '160 ms',
                            numericValue: 159,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'largest-contentful-paint',
                            title: 'Largest Contentful Paint',
                            description:
                                'Largest Contentful Paint marks the time at which the largest text or image is painted. [Learn more](https://web.dev/lighthouse-largest-contentful-paint/)',
                            score: 0.85,
                            scoreDisplayMode: 'numeric',
                            displayValue: '1.4 s',
                            numericValue: 1354.5,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'render-blocking-resources',
                            title: 'Eliminate render-blocking resources',
                            description:
                                'Resources are blocking the first paint of your page. Consider delivering critical JS/CSS inline and deferring all non-critical JS/styles. [Learn more](https://web.dev/render-blocking-resources/).',
                            score: 0.88,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 150 ms',
                            details: {
                                type: 'opportunity',
                                overallSavingsMs: 150,
                                headings: [
                                    {
                                        valueType: 'url',
                                        label: 'URL',
                                        key: 'url',
                                    },
                                    {
                                        label: 'Transfer Size',
                                        valueType: 'bytes',
                                        key: 'totalBytes',
                                    },
                                    {
                                        key: 'wastedMs',
                                        valueType: 'timespanMs',
                                        label: 'Potential Savings',
                                    },
                                ],
                                items: [
                                    {
                                        wastedMs: 110,
                                        totalBytes: 10468,
                                        url: 'https://www.rotorooter.com/styles.4fe6d142c78b045262be.css',
                                    },
                                ],
                            },
                            numericValue: 150,
                            numericUnit: 'millisecond',
                        },
                    ],
                },
                shouldFix: {
                    length: 1,
                    data: [
                        {
                            id: 'font-display',
                            title: 'Ensure text remains visible during webfont load',
                            description:
                                'Leverage the font-display CSS feature to ensure text is user-visible while webfonts are loading. [Learn more](https://web.dev/font-display/).',
                            score: 0,
                            scoreDisplayMode: 'binary',
                            details: {
                                items: [
                                    {
                                        url: 'https://use.typekit.net/af/46da36/00000000000000003b9acaf6/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                        wastedMs: 23.274000734090805,
                                    },
                                    {
                                        wastedMs: 23.432999849319458,
                                        url: 'https://use.typekit.net/af/6d4bb2/00000000000000003b9acafc/27/l?fvd=n7&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                    },
                                    {
                                        url: 'https://use.typekit.net/af/cfbead/0000000000000000000146b3/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                        wastedMs: 23.50699994713068,
                                    },
                                ],
                                headings: [
                                    {
                                        text: 'URL',
                                        key: 'url',
                                        itemType: 'url',
                                    },
                                    {
                                        itemType: 'ms',
                                        key: 'wastedMs',
                                        text: 'Potential Savings',
                                    },
                                ],
                                type: 'table',
                            },
                            warnings: [],
                        },
                    ],
                },
            },
            mobile: {
                grade: 'C',
                screenshot:
                    'data:image/jpeg;base64,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',
                passed: {
                    length: 25,
                    data: [
                        {
                            id: 'unsized-images',
                            title: 'Image elements have explicit `width` and `height`',
                            description:
                                'Set an explicit width and height on image elements to reduce layout shifts and improve CLS. [Learn more](https://web.dev/optimize-cls/#images-without-dimensions)',
                            score: 1,
                            scoreDisplayMode: 'binary',
                            details: {
                                headings: [],
                                type: 'table',
                                items: [],
                            },
                        },
                        {
                            id: 'unminified-css',
                            title: 'Minify CSS',
                            description:
                                'Minifying CSS files can reduce network payload sizes. [Learn more](https://web.dev/unminified-css/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                headings: [],
                                type: 'opportunity',
                                overallSavingsMs: 0,
                                overallSavingsBytes: 0,
                                items: [],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-rel-preload',
                            title: 'Preload key requests',
                            description:
                                'Consider using `<link rel=preload>` to prioritize fetching resources that are currently requested later in page load. [Learn more](https://web.dev/uses-rel-preload/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                overallSavingsMs: 0,
                                headings: [],
                                type: 'opportunity',
                                items: [],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'total-byte-weight',
                            title: 'Avoids enormous network payloads',
                            description:
                                'Large network payloads cost users real money and are highly correlated with long load times. [Learn more](https://web.dev/total-byte-weight/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Total size was 471 KiB',
                            details: {
                                type: 'table',
                                headings: [
                                    {
                                        key: 'url',
                                        text: 'URL',
                                        itemType: 'url',
                                    },
                                    {
                                        key: 'totalBytes',
                                        itemType: 'bytes',
                                        text: 'Transfer Size',
                                    },
                                ],
                                items: [
                                    {
                                        totalBytes: 216962,
                                        url: 'https://www.rotorooter.com/vendor-es2015.536e6f78051d9ce391bc.js',
                                    },
                                    {
                                        url: 'https://www.rotorooter.com/main-es2015.201ea8f097437a77e69f.js',
                                        totalBytes: 111007,
                                    },
                                    {
                                        totalBytes: 48201,
                                        url: 'https://www.rotorooter.com/',
                                    },
                                    {
                                        url: 'https://cdn.rotorootercdn.com/images/images/hero/home-hero-mob.png',
                                        totalBytes: 22509,
                                    },
                                    {
                                        url: 'https://use.typekit.net/af/6d4bb2/00000000000000003b9acafc/27/a?fvd=n7&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                        totalBytes: 19438,
                                    },
                                    {
                                        totalBytes: 18582,
                                        url: 'https://use.typekit.net/af/cfbead/0000000000000000000146b3/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                    },
                                    {
                                        url: 'https://use.typekit.net/af/46da36/00000000000000003b9acaf6/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                        totalBytes: 16862,
                                    },
                                    {
                                        url: 'https://www.rotorooter.com/polyfills-es2015.4d4244071d265f56206f.js',
                                        totalBytes: 12830,
                                    },
                                    {
                                        totalBytes: 10461,
                                        url: 'https://www.rotorooter.com/styles.4fe6d142c78b045262be.css',
                                    },
                                    {
                                        url: 'https://www.rotorooter.com/runtime-es2015.3485e797aee36e1c5759.js',
                                        totalBytes: 2583,
                                    },
                                ],
                            },
                            numericValue: 482692,
                            numericUnit: 'byte',
                        },
                        {
                            id: 'cumulative-layout-shift',
                            title: 'Cumulative Layout Shift',
                            description:
                                'Cumulative Layout Shift measures the movement of visible elements within the viewport. [Learn more](https://web.dev/cls/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: '0.028',
                            details: {
                                items: [
                                    {
                                        totalCumulativeLayoutShift: 0.02830807113647461,
                                        cumulativeLayoutShiftMainFrame: 0.02830807113647461,
                                    },
                                ],
                                type: 'debugdata',
                            },
                            numericValue: 0.02830807113647461,
                            numericUnit: 'unitless',
                        },
                        {
                            id: 'uses-optimized-images',
                            title: 'Efficiently encode images',
                            description:
                                'Optimized images load faster and consume less cellular data. [Learn more](https://web.dev/uses-optimized-images/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                type: 'opportunity',
                                overallSavingsBytes: 0,
                                headings: [],
                                overallSavingsMs: 0,
                                items: [],
                            },
                            warnings: [],
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'unused-css-rules',
                            title: 'Reduce unused CSS',
                            description:
                                'Reduce unused rules from stylesheets and defer CSS not used for above-the-fold content to decrease bytes consumed by network activity. [Learn more](https://web.dev/unused-css-rules/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                headings: [],
                                overallSavingsMs: 0,
                                items: [],
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'preload-lcp-image',
                            title: 'Preload Largest Contentful Paint image',
                            description:
                                'Preload the image used by the LCP element in order to improve your LCP time. [Learn more](https://web.dev/optimize-lcp/#preload-important-resources).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                type: 'opportunity',
                                overallSavingsMs: 0,
                                headings: [
                                    {
                                        valueType: 'thumbnail',
                                        key: 'url',
                                    },
                                    {
                                        key: 'url',
                                        valueType: 'url',
                                        label: 'URL',
                                    },
                                    {
                                        key: 'wastedMs',
                                        label: 'Potential Savings',
                                        valueType: 'timespanMs',
                                    },
                                ],
                                items: [
                                    {
                                        url: 'https://cdn.rotorootercdn.com/images/images/hero/home-hero-mob.png',
                                        wastedMs: 0,
                                    },
                                ],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-text-compression',
                            title: 'Enable text compression',
                            description:
                                'Text-based resources should be served with compression (gzip, deflate or brotli) to minimize total network bytes. [Learn more](https://web.dev/uses-text-compression/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                overallSavingsMs: 0,
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                                items: [],
                                headings: [],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'redirects',
                            title: 'Avoid multiple page redirects',
                            description:
                                'Redirects introduce additional delays before the page can be loaded. [Learn more](https://web.dev/redirects/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                headings: [],
                                overallSavingsMs: 0,
                                items: [],
                                type: 'opportunity',
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'offscreen-images',
                            title: 'Defer offscreen images',
                            description:
                                'Consider lazy-loading offscreen and hidden images after all critical resources have finished loading to lower time to interactive. [Learn more](https://web.dev/offscreen-images/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                overallSavingsMs: 0,
                                items: [],
                                headings: [],
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                            },
                            warnings: [],
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'unminified-javascript',
                            title: 'Minify JavaScript',
                            description:
                                'Minifying JavaScript files can reduce payload sizes and script parse time. [Learn more](https://web.dev/unminified-javascript/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 2 KiB',
                            details: {
                                items: [
                                    {
                                        wastedBytes: 2177,
                                        totalBytes: 2375,
                                        url: 'inline: {&q;itemListing-&q;:{&q;data&q;:{&q;getR...',
                                        wastedPercent: 91.65870188548094,
                                    },
                                ],
                                type: 'opportunity',
                                overallSavingsBytes: 2177,
                                headings: [
                                    {
                                        key: 'url',
                                        label: 'URL',
                                        valueType: 'url',
                                    },
                                    {
                                        label: 'Transfer Size',
                                        key: 'totalBytes',
                                        valueType: 'bytes',
                                    },
                                    {
                                        valueType: 'bytes',
                                        key: 'wastedBytes',
                                        label: 'Potential Savings',
                                    },
                                ],
                                overallSavingsMs: 0,
                            },
                            warnings: [],
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-rel-preconnect',
                            title: 'Preconnect to required origins',
                            description:
                                'Consider adding `preconnect` or `dns-prefetch` resource hints to establish early connections to important third-party origins. [Learn more](https://web.dev/uses-rel-preconnect/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            warnings: [
                                'A `<link rel=preconnect>` was found for "https://rotorooterinc.tt.omtrdc.net" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'A `<link rel=preconnect>` was found for "https://www.googletagmanager.com" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'A `<link rel=preconnect>` was found for "https://www.google-analytics.com" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'A `<link rel=preconnect>` was found for "https://www.google.com" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'A `<link rel=preconnect>` was found for "https://stats.g.doubleclick.net" but was not used by the browser. Only use `preconnect` for important origins that the page will certainly request.',
                                'More than 2 `<link rel=preconnect>` connections were found. These should be used sparingly and only to the most important origins.',
                            ],
                        },
                        {
                            id: 'dom-size',
                            title: 'Avoids an excessive DOM size',
                            description:
                                'A large DOM will increase memory usage, cause longer [style calculations](https://developers.google.com/web/fundamentals/performance/rendering/reduce-the-scope-and-complexity-of-style-calculations), and produce costly [layout reflows](https://developers.google.com/speed/articles/reflow). [Learn more](https://web.dev/dom-size/).',
                            score: 0.96,
                            scoreDisplayMode: 'numeric',
                            displayValue: '663 elements',
                            details: {
                                headings: [
                                    {
                                        text: 'Statistic',
                                        itemType: 'text',
                                        key: 'statistic',
                                    },
                                    {
                                        key: 'node',
                                        itemType: 'node',
                                        text: 'Element',
                                    },
                                    {
                                        text: 'Value',
                                        itemType: 'numeric',
                                        key: 'value',
                                    },
                                ],
                                type: 'table',
                                items: [
                                    {
                                        value: 663,
                                        statistic: 'Total DOM Elements',
                                    },
                                    {
                                        statistic: 'Maximum DOM Depth',
                                        value: 18,
                                        node: {
                                            path: '1,HTML,1,BODY,0,APP-ROOT,1,DIV,1,APP-HOME,0,APP-PRIMARY-BANNER,0,DIV,0,DIV,0,DIV,1,DIV,4,DIV,2,DIV,0,APP-FYLP,0,DIV,0,DIV,2,DIV,1,A,0,svg,0,path',
                                            snippet:
                                                '<path _ngcontent-app-c16="" d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z" fill="#fff">',
                                            lhId: '6-49-path',
                                            type: 'node',
                                            selector:
                                                'div.flypInputWrap > a.fylpBtn > svg.header-fylp-btn > path',
                                            nodeLabel: 'path',
                                            boundingRect: {
                                                bottom: 451,
                                                height: 21,
                                                width: 13,
                                                left: 287,
                                                right: 300,
                                                top: 430,
                                            },
                                        },
                                    },
                                    {
                                        node: {
                                            boundingRect: {
                                                top: 0,
                                                left: 0,
                                                width: 0,
                                                height: 0,
                                                right: 0,
                                                bottom: 0,
                                            },
                                            path: '1,HTML,1,BODY,0,APP-ROOT,0,APP-HEADER,1,HEADER,0,DIV,1,DIV,0,DIV,0,DIV,0,DIV,0,DIV,0,A,0,svg,3,g',
                                            selector: 'div.desktop-logo > a > svg.svg-logo > g',
                                            lhId: '6-50-g',
                                            type: 'node',
                                            snippet: '<g>',
                                            nodeLabel: 'g',
                                        },
                                        statistic: 'Maximum Child Elements',
                                        value: 25,
                                    },
                                ],
                            },
                            numericValue: 663,
                            numericUnit: 'element',
                        },
                        {
                            id: 'uses-long-cache-ttl',
                            title: 'Uses efficient cache policy on static assets',
                            description:
                                'A long cache lifetime can speed up repeat visits to your page. [Learn more](https://web.dev/uses-long-cache-ttl/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: '0 resources found',
                            details: {
                                summary: {
                                    wastedBytes: 0,
                                },
                                type: 'table',
                                items: [],
                                headings: [],
                            },
                            numericValue: 0,
                            numericUnit: 'byte',
                        },
                        {
                            id: 'efficient-animated-content',
                            title: 'Use video formats for animated content',
                            description:
                                'Large GIFs are inefficient for delivering animated content. Consider using MPEG4/WebM videos for animations and PNG/WebP for static images instead of GIF to save network bytes. [Learn more](https://web.dev/efficient-animated-content/)',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                                overallSavingsMs: 0,
                                items: [],
                                headings: [],
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'third-party-summary',
                            title: 'Minimize third-party usage',
                            description:
                                'Third-party code can significantly impact load performance. Limit the number of redundant third-party providers and try to load third-party code after your page has primarily finished loading. [Learn more](https://developers.google.com/web/fundamentals/performance/optimizing-content-efficiency/loading-third-party-javascript/).',
                            score: 1,
                            scoreDisplayMode: 'binary',
                            displayValue: 'Third-party code blocked the main thread for 0 ms',
                            details: {
                                items: [
                                    {
                                        subItems: {
                                            items: [
                                                {
                                                    mainThreadTime: 0,
                                                    transferSize: 19438,
                                                    blockingTime: 0,
                                                    url: 'https://use.typekit.net/af/6d4bb2/00000000000000003b9acafc/27/a?fvd=n7&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                                },
                                                {
                                                    transferSize: 18582,
                                                    mainThreadTime: 0,
                                                    url: 'https://use.typekit.net/af/cfbead/0000000000000000000146b3/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                                    blockingTime: 0,
                                                },
                                                {
                                                    blockingTime: 0,
                                                    transferSize: 16862,
                                                    url: 'https://use.typekit.net/af/46da36/00000000000000003b9acaf6/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                                    mainThreadTime: 0,
                                                },
                                            ],
                                            type: 'subitems',
                                        },
                                        mainThreadTime: 0,
                                        entity: {
                                            url: 'https://fonts.adobe.com/',
                                            type: 'link',
                                            text: 'Adobe TypeKit',
                                        },
                                        blockingTime: 0,
                                        transferSize: 54882,
                                    },
                                ],
                                type: 'table',
                                summary: {
                                    wastedMs: 0,
                                    wastedBytes: 54882,
                                },
                                headings: [
                                    {
                                        itemType: 'link',
                                        subItemsHeading: {
                                            key: 'url',
                                            itemType: 'url',
                                        },
                                        text: 'Third-Party',
                                        key: 'entity',
                                    },
                                    {
                                        subItemsHeading: {
                                            key: 'transferSize',
                                        },
                                        text: 'Transfer Size',
                                        granularity: 1,
                                        key: 'transferSize',
                                        itemType: 'bytes',
                                    },
                                    {
                                        granularity: 1,
                                        key: 'blockingTime',
                                        text: 'Main-Thread Blocking Time',
                                        subItemsHeading: {
                                            key: 'blockingTime',
                                        },
                                        itemType: 'ms',
                                    },
                                ],
                            },
                        },
                        {
                            id: 'server-response-time',
                            title: 'Initial server response time was short',
                            description:
                                'Keep the server response time for the main document short because all other requests depend on it. [Learn more](https://web.dev/time-to-first-byte/).',
                            score: 1,
                            scoreDisplayMode: 'binary',
                            displayValue: 'Root document took 380 ms',
                            details: {
                                type: 'opportunity',
                                items: [
                                    {
                                        url: 'https://www.rotorooter.com/',
                                        responseTime: 379.581,
                                    },
                                ],
                                headings: [
                                    {
                                        key: 'url',
                                        valueType: 'url',
                                        label: 'URL',
                                    },
                                    {
                                        label: 'Time Spent',
                                        key: 'responseTime',
                                        valueType: 'timespanMs',
                                    },
                                ],
                                overallSavingsMs: 279.581,
                            },
                            numericValue: 379.581,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'modern-image-formats',
                            title: 'Serve images in next-gen formats',
                            description:
                                'Image formats like JPEG 2000, JPEG XR, and WebP often provide better compression than PNG or JPEG, which means faster downloads and less data consumption. [Learn more](https://web.dev/uses-webp-images/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                headings: [],
                                overallSavingsMs: 0,
                                items: [],
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                            },
                            warnings: [],
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'legacy-javascript',
                            title: 'Avoid serving legacy JavaScript to modern browsers',
                            description:
                                "Polyfills and transforms enable legacy browsers to use new JavaScript features. However, many aren't necessary for modern browsers. For your bundled JavaScript, adopt a modern script deployment strategy using module/nomodule feature detection to reduce the amount of code shipped to modern browsers, while retaining support for legacy browsers. [Learn More](https://philipwalton.com/articles/deploying-es2015-code-in-production-today/)",
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 0 KiB',
                            details: {
                                overallSavingsBytes: 45,
                                items: [
                                    {
                                        totalBytes: 0,
                                        url: 'https://www.rotorooter.com/vendor-es2015.536e6f78051d9ce391bc.js',
                                        wastedBytes: 45,
                                        subItems: {
                                            items: [
                                                {
                                                    signal: '@babel/plugin-transform-classes',
                                                    location: {
                                                        urlProvider: 'network',
                                                        line: 0,
                                                        column: 347555,
                                                        url: 'https://www.rotorooter.com/vendor-es2015.536e6f78051d9ce391bc.js',
                                                        type: 'source-location',
                                                    },
                                                },
                                            ],
                                            type: 'subitems',
                                        },
                                    },
                                ],
                                type: 'opportunity',
                                headings: [
                                    {
                                        key: 'url',
                                        subItemsHeading: {
                                            key: 'location',
                                            valueType: 'source-location',
                                        },
                                        valueType: 'url',
                                        label: 'URL',
                                    },
                                    {
                                        subItemsHeading: {
                                            key: 'signal',
                                        },
                                        key: null,
                                        valueType: 'code',
                                    },
                                    {
                                        valueType: 'bytes',
                                        label: 'Potential Savings',
                                        key: 'wastedBytes',
                                    },
                                ],
                                overallSavingsMs: 0,
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'uses-passive-event-listeners',
                            title: 'Uses passive listeners to improve scrolling performance',
                            description:
                                "Consider marking your touch and wheel event listeners as `passive` to improve your page's scroll performance. [Learn more](https://web.dev/uses-passive-event-listeners/).",
                            score: 1,
                            scoreDisplayMode: 'binary',
                            details: {
                                items: [],
                                headings: [],
                                type: 'table',
                            },
                        },
                        {
                            id: 'uses-responsive-images',
                            title: 'Properly size images',
                            description:
                                'Serve images that are appropriately-sized to save cellular data and improve load time. [Learn more](https://web.dev/uses-responsive-images/).',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                items: [],
                                overallSavingsBytes: 0,
                                type: 'opportunity',
                                headings: [],
                                overallSavingsMs: 0,
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'no-document-write',
                            title: 'Avoids `document.write()`',
                            description:
                                'For users on slow connections, external scripts dynamically injected via `document.write()` can delay page load by tens of seconds. [Learn more](https://web.dev/no-document-write/).',
                            score: 1,
                            scoreDisplayMode: 'binary',
                            details: {
                                type: 'table',
                                items: [],
                                headings: [],
                            },
                        },
                        {
                            id: 'duplicated-javascript',
                            title: 'Remove duplicate modules in JavaScript bundles',
                            description:
                                'Remove large, duplicate JavaScript modules from bundles to reduce unnecessary bytes consumed by network activity. ',
                            score: 1,
                            scoreDisplayMode: 'numeric',
                            details: {
                                headings: [],
                                overallSavingsBytes: 0,
                                items: [],
                                overallSavingsMs: 0,
                                type: 'opportunity',
                            },
                            numericValue: 0,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'speed-index',
                            title: 'Speed Index',
                            description:
                                'Speed Index shows how quickly the contents of a page are visibly populated. [Learn more](https://web.dev/speed-index/).',
                            score: 0.94,
                            scoreDisplayMode: 'numeric',
                            displayValue: '3.0 s',
                            numericValue: 2988.6435032781537,
                            numericUnit: 'millisecond',
                        },
                    ],
                },
                considerFixing: {
                    length: 6,
                    data: [
                        {
                            id: 'unused-javascript',
                            title: 'Reduce unused JavaScript',
                            description:
                                'Reduce unused JavaScript and defer loading scripts until they are required to decrease bytes consumed by network activity. [Learn more](https://web.dev/unused-javascript/).',
                            score: 0.58,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 127 KiB',
                            details: {
                                type: 'opportunity',
                                overallSavingsMs: 600,
                                overallSavingsBytes: 130421,
                                items: [
                                    {
                                        url: 'https://www.rotorooter.com/vendor-es2015.536e6f78051d9ce391bc.js',
                                        totalBytes: 216962,
                                        wastedPercent: 48.91315274439015,
                                        wastedBytes: 106123,
                                    },
                                    {
                                        totalBytes: 111007,
                                        wastedBytes: 24298,
                                        wastedPercent: 21.888383668355626,
                                        url: 'https://www.rotorooter.com/main-es2015.201ea8f097437a77e69f.js',
                                    },
                                ],
                                headings: [
                                    {
                                        subItemsHeading: {
                                            valueType: 'code',
                                            key: 'source',
                                        },
                                        valueType: 'url',
                                        key: 'url',
                                        label: 'URL',
                                    },
                                    {
                                        valueType: 'bytes',
                                        subItemsHeading: {
                                            key: 'sourceBytes',
                                        },
                                        key: 'totalBytes',
                                        label: 'Transfer Size',
                                    },
                                    {
                                        valueType: 'bytes',
                                        subItemsHeading: {
                                            key: 'sourceWastedBytes',
                                        },
                                        label: 'Potential Savings',
                                        key: 'wastedBytes',
                                    },
                                ],
                            },
                            numericValue: 600,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'bootup-time',
                            title: 'Reduce JavaScript execution time',
                            description:
                                'Consider reducing the time spent parsing, compiling, and executing JS. You may find delivering smaller JS payloads helps with this. [Learn more](https://web.dev/bootup-time/).',
                            score: 0.82,
                            scoreDisplayMode: 'numeric',
                            displayValue: '1.7 s',
                            details: {
                                items: [
                                    {
                                        url: 'https://www.rotorooter.com/polyfills-es2015.4d4244071d265f56206f.js',
                                        scriptParseCompile: 1.476,
                                        scripting: 1556.5439999999994,
                                        total: 1712.5759999999993,
                                    },
                                    {
                                        scriptParseCompile: 3.924,
                                        total: 773.776,
                                        url: 'https://www.rotorooter.com/',
                                        scripting: 7.095999999999997,
                                    },
                                    {
                                        url: 'Unattributable',
                                        total: 441.9560000000001,
                                        scripting: 162.1040000000001,
                                        scriptParseCompile: 1.264,
                                    },
                                ],
                                type: 'table',
                                headings: [
                                    {
                                        itemType: 'url',
                                        key: 'url',
                                        text: 'URL',
                                    },
                                    {
                                        itemType: 'ms',
                                        text: 'Total CPU Time',
                                        key: 'total',
                                        granularity: 1,
                                    },
                                    {
                                        text: 'Script Evaluation',
                                        key: 'scripting',
                                        granularity: 1,
                                        itemType: 'ms',
                                    },
                                    {
                                        key: 'scriptParseCompile',
                                        itemType: 'ms',
                                        granularity: 1,
                                        text: 'Script Parse',
                                    },
                                ],
                                summary: {
                                    wastedMs: 1732.4079999999997,
                                },
                            },
                            numericValue: 1732.4079999999997,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'interactive',
                            title: 'Time to Interactive',
                            description:
                                'Time to interactive is the amount of time it takes for the page to become fully interactive. [Learn more](https://web.dev/interactive/).',
                            score: 0.73,
                            scoreDisplayMode: 'numeric',
                            displayValue: '5.3 s',
                            numericValue: 5306.5,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'total-blocking-time',
                            title: 'Total Blocking Time',
                            description:
                                'Sum of all time periods between FCP and Time to Interactive, when task length exceeded 50ms, expressed in milliseconds. [Learn more](https://web.dev/lighthouse-total-blocking-time/).',
                            score: 0.5,
                            scoreDisplayMode: 'numeric',
                            displayValue: '600 ms',
                            numericValue: 598.5,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'mainthread-work-breakdown',
                            title: 'Minimize main-thread work',
                            description:
                                'Consider reducing the time spent parsing, compiling and executing JS. You may find delivering smaller JS payloads helps with this. [Learn more](https://web.dev/mainthread-work-breakdown/)',
                            score: 0.7,
                            scoreDisplayMode: 'numeric',
                            displayValue: '3.0 s',
                            details: {
                                headings: [
                                    {
                                        text: 'Category',
                                        key: 'groupLabel',
                                        itemType: 'text',
                                    },
                                    {
                                        itemType: 'ms',
                                        key: 'duration',
                                        granularity: 1,
                                        text: 'Time Spent',
                                    },
                                ],
                                items: [
                                    {
                                        group: 'scriptEvaluation',
                                        groupLabel: 'Script Evaluation',
                                        duration: 1725.7439999999997,
                                    },
                                    {
                                        duration: 573.088,
                                        groupLabel: 'Style & Layout',
                                        group: 'styleLayout',
                                    },
                                    {
                                        duration: 373.1720000000003,
                                        groupLabel: 'Other',
                                        group: 'other',
                                    },
                                    {
                                        groupLabel: 'Rendering',
                                        group: 'paintCompositeRender',
                                        duration: 149.68400000000003,
                                    },
                                    {
                                        group: 'parseHTML',
                                        groupLabel: 'Parse HTML & CSS',
                                        duration: 77.71600000000001,
                                    },
                                    {
                                        groupLabel: 'Garbage Collection',
                                        group: 'garbageCollection',
                                        duration: 75.07199999999999,
                                    },
                                    {
                                        groupLabel: 'Script Parsing & Compilation',
                                        group: 'scriptParseCompile',
                                        duration: 37.168,
                                    },
                                ],
                                type: 'table',
                            },
                            numericValue: 3011.6440000000002,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'first-contentful-paint',
                            title: 'First Contentful Paint',
                            description:
                                'First Contentful Paint marks the time at which the first text or image is painted. [Learn more](https://web.dev/first-contentful-paint/).',
                            score: 0.72,
                            scoreDisplayMode: 'numeric',
                            displayValue: '2.4 s',
                            numericValue: 2370,
                            numericUnit: 'millisecond',
                        },
                    ],
                },
                shouldFix: {
                    length: 6,
                    data: [
                        {
                            id: 'largest-contentful-paint',
                            title: 'Largest Contentful Paint',
                            description:
                                'Largest Contentful Paint marks the time at which the largest text or image is painted. [Learn more](https://web.dev/lighthouse-largest-contentful-paint/)',
                            score: 0.19,
                            scoreDisplayMode: 'numeric',
                            displayValue: '5.5 s',
                            numericValue: 5518,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'render-blocking-resources',
                            title: 'Eliminate render-blocking resources',
                            description:
                                'Resources are blocking the first paint of your page. Consider delivering critical JS/CSS inline and deferring all non-critical JS/styles. [Learn more](https://web.dev/render-blocking-resources/).',
                            score: 0.44,
                            scoreDisplayMode: 'numeric',
                            displayValue: 'Potential savings of 1,300 ms',
                            details: {
                                items: [
                                    {
                                        totalBytes: 10461,
                                        url: 'https://www.rotorooter.com/styles.4fe6d142c78b045262be.css',
                                        wastedMs: 180,
                                    },
                                ],
                                type: 'opportunity',
                                overallSavingsMs: 1296,
                                headings: [
                                    {
                                        label: 'URL',
                                        valueType: 'url',
                                        key: 'url',
                                    },
                                    {
                                        key: 'totalBytes',
                                        valueType: 'bytes',
                                        label: 'Transfer Size',
                                    },
                                    {
                                        valueType: 'timespanMs',
                                        key: 'wastedMs',
                                        label: 'Potential Savings',
                                    },
                                ],
                            },
                            numericValue: 1296,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'max-potential-fid',
                            title: 'Max Potential First Input Delay',
                            description:
                                'The maximum potential First Input Delay that your users could experience is the duration of the longest task. [Learn more](https://web.dev/lighthouse-max-potential-fid/).',
                            score: 0.03,
                            scoreDisplayMode: 'numeric',
                            displayValue: '640 ms',
                            numericValue: 637,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'first-contentful-paint-3g',
                            title: 'First Contentful Paint (3G)',
                            description:
                                'First Contentful Paint 3G marks the time at which the first text or image is painted while on a 3G network. [Learn more](https://developers.google.com/web/tools/lighthouse/audits/first-contentful-paint).',
                            score: 0.44,
                            scoreDisplayMode: 'numeric',
                            displayValue: '4770 ms',
                            numericValue: 4770,
                            numericUnit: 'millisecond',
                        },
                        {
                            id: 'font-display',
                            title: 'Ensure text remains visible during webfont load',
                            description:
                                'Leverage the font-display CSS feature to ensure text is user-visible while webfonts are loading. [Learn more](https://web.dev/font-display/).',
                            score: 0,
                            scoreDisplayMode: 'binary',
                            details: {
                                headings: [
                                    {
                                        itemType: 'url',
                                        key: 'url',
                                        text: 'URL',
                                    },
                                    {
                                        text: 'Potential Savings',
                                        itemType: 'ms',
                                        key: 'wastedMs',
                                    },
                                ],
                                type: 'table',
                                items: [
                                    {
                                        url: 'https://use.typekit.net/af/46da36/00000000000000003b9acaf6/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                        wastedMs: 5.3029999835416675,
                                    },
                                    {
                                        url: 'https://use.typekit.net/af/6d4bb2/00000000000000003b9acafc/27/l?fvd=n7&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                        wastedMs: 56.883999961428344,
                                    },
                                    {
                                        wastedMs: 6.882000016048551,
                                        url: 'https://use.typekit.net/af/cfbead/0000000000000000000146b3/27/l?fvd=n4&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                    },
                                    {
                                        url: 'https://use.typekit.net/af/6d4bb2/00000000000000003b9acafc/27/d?fvd=n7&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                        wastedMs: 26.570999994874,
                                    },
                                    {
                                        wastedMs: 95.3999999910593,
                                        url: 'https://use.typekit.net/af/6d4bb2/00000000000000003b9acafc/27/a?fvd=n7&primer=057d1dff47772f391f5f6c189aa213bb70116047eaffac2e52d3626ff163c8d1&v=3',
                                    },
                                ],
                            },
                            warnings: [],
                        },
                        {
                            id: 'first-meaningful-paint',
                            title: 'First Meaningful Paint',
                            description:
                                'First Meaningful Paint measures when the primary content of a page is visible. [Learn more](https://web.dev/first-meaningful-paint/).',
                            score: 0.38,
                            scoreDisplayMode: 'numeric',
                            displayValue: '4.5 s',
                            numericValue: 4536.5,
                            numericUnit: 'millisecond',
                        },
                    ],
                },
            },
        },
        seo: {
            grade: 'A',
            organicCompetitorAnalysis: [
                {
                    domain: 'rotorooter.com',
                    overlap: '',
                    keywords: 80634,
                    clicks: 509862,
                    value: 5119421,
                },
                {
                    domain: 'mrrooter.com',
                    overlap: 29,
                    keywords: 101476,
                    clicks: 329012,
                    value: 1929982,
                },
                {
                    domain: 'benjaminfranklinplumbing.com',
                    overlap: 13,
                    keywords: 45605,
                    clicks: 113979,
                    value: 1039604,
                },
                {
                    domain: 'lentheplumber.com',
                    overlap: 10,
                    keywords: 16757,
                    clicks: 76749,
                    value: 801569,
                },
                {
                    domain: 'rooterman.com',
                    overlap: 9,
                    keywords: 15779,
                    clicks: 9390,
                    value: 52880,
                },
                {
                    domain: 'bestplumbers.com',
                    overlap: 7,
                    keywords: 13099,
                    clicks: 1679,
                    value: 15317,
                },
                {
                    domain: 'ars.com',
                    overlap: 7,
                    keywords: 25150,
                    clicks: 149469,
                    value: 1416958,
                },
                {
                    domain: 'superterry.com',
                    overlap: 7,
                    keywords: 28948,
                    clicks: 39287,
                    value: 150054,
                },
                {
                    domain: 'theoriginalplumber.com',
                    overlap: 7,
                    keywords: 5933,
                    clicks: 16718,
                    value: 85647,
                },
                {
                    domain: 'mrplumberatlanta.com',
                    overlap: 6,
                    keywords: 16576,
                    clicks: 42156,
                    value: 371007,
                },
                {
                    domain: 'mikediamondservices.com',
                    overlap: 6,
                    keywords: 21790,
                    clicks: 58993,
                    value: 317007,
                },
            ],
            organicKeywordRanking: [
                {
                    keyword: 'staples near me',
                    keywordDifficulty: 3,
                    position: 38,
                    searchVolume: 823000,
                    results: 97,
                },
                {
                    keyword: 'plumber near me',
                    keywordDifficulty: 73,
                    position: 11,
                    searchVolume: 673000,
                    results: 524000000,
                },
                {
                    keyword: 'plumber near me',
                    keywordDifficulty: 73,
                    position: 12,
                    searchVolume: 673000,
                    results: 524000000,
                },
                {
                    keyword: 'plumber',
                    keywordDifficulty: 34,
                    position: 89,
                    searchVolume: 368000,
                    results: 711000000,
                },
                {
                    keyword: 'plumbers near me',
                    keywordDifficulty: 87,
                    position: 13,
                    searchVolume: 368000,
                    results: 706000000,
                },
                {
                    keyword: 'water heater',
                    keywordDifficulty: 100,
                    position: 58,
                    searchVolume: 165000,
                    results: 340000000,
                },
                {
                    keyword: 'garbage disposal',
                    keywordDifficulty: 100,
                    position: 29,
                    searchVolume: 165000,
                    results: 581000000,
                },
                {
                    keyword: 'roto rooter',
                    keywordDifficulty: 44,
                    position: 1,
                    searchVolume: 165000,
                    results: 2150000,
                },
                {
                    keyword: 'septic tank',
                    keywordDifficulty: 100,
                    position: 69,
                    searchVolume: 110000,
                    results: 57700000,
                },
                {
                    keyword: 'sump pumps',
                    keywordDifficulty: 100,
                    position: 71,
                    searchVolume: 110000,
                    results: 29700000,
                },
            ],
            backlinks: {
                totalBacklinks: 1189095,
                referringDomains: 5313,
                referringsIPs: 5616,
                authorityScore: 56,
                backlinksTypes: {
                    text: {
                        number: 227270,
                        percentage: 19.11,
                    },
                    image: {
                        number: 840114,
                        percentage: 70.65,
                    },
                    form: {
                        number: 0,
                        percentage: 0,
                    },
                    frame: {
                        number: 16,
                        percentage: 0,
                    },
                },
                follow: {
                    number: 1015023,
                    percentage: 85.36,
                },
                noFollow: {
                    number: 169497,
                    percentage: 14.25,
                },
            },
        },
        googleAds: {
            grade: 'C',
            overview: {
                keywords: 6559,
                traffic: 286031,
                trafficCost: 2858381,
            },
            competitorAnalysis: [
                {
                    domain: 'rescuerooter-seattle.com',
                    competitionLevel: 15,
                    commonKeywords: 660,
                    paidKeywords: 2020,
                    paidKeywordsPrice: 2057462,
                    paidTraffic: 149456,
                    seKeywords: 0,
                },
                {
                    domain: 'benjaminfranklinplumbing.com',
                    competitionLevel: 11,
                    commonKeywords: 502,
                    paidKeywords: 1958,
                    paidKeywordsPrice: 1227315,
                    paidTraffic: 122529,
                    seKeywords: 45605,
                },
                {
                    domain: 'mrrooter.com',
                    competitionLevel: 9,
                    commonKeywords: 399,
                    paidKeywords: 1571,
                    paidKeywordsPrice: 486485,
                    paidTraffic: 52418,
                    seKeywords: 101476,
                },
                {
                    domain: 'gillece.com',
                    competitionLevel: 9,
                    commonKeywords: 777,
                    paidKeywords: 9946,
                    paidKeywordsPrice: 4071885,
                    paidTraffic: 307258,
                    seKeywords: 3346,
                },
                {
                    domain: 'mrrooter-usa.com',
                    competitionLevel: 9,
                    commonKeywords: 375,
                    paidKeywords: 1252,
                    paidKeywordsPrice: 123910,
                    paidTraffic: 13547,
                    seKeywords: 0,
                },
                {
                    domain: 'morrisjenkins.com',
                    competitionLevel: 9,
                    commonKeywords: 490,
                    paidKeywords: 4528,
                    paidKeywordsPrice: 2468036,
                    paidTraffic: 216201,
                    seKeywords: 4541,
                },
                {
                    domain: 'rooterplus.com',
                    competitionLevel: 7,
                    commonKeywords: 392,
                    paidKeywords: 4405,
                    paidKeywordsPrice: 2556763,
                    paidTraffic: 231155,
                    seKeywords: 603,
                },
                {
                    domain: 'callcatons.com',
                    competitionLevel: 7,
                    commonKeywords: 326,
                    paidKeywords: 2548,
                    paidKeywordsPrice: 2008064,
                    paidTraffic: 177086,
                    seKeywords: 499,
                },
                {
                    domain: 'rootertown.com',
                    competitionLevel: 6,
                    commonKeywords: 239,
                    paidKeywords: 1252,
                    paidKeywordsPrice: 1059610,
                    paidTraffic: 86352,
                    seKeywords: 230,
                },
                {
                    domain: 'rescuerooter-los-angeles.com',
                    competitionLevel: 6,
                    commonKeywords: 219,
                    paidKeywords: 852,
                    paidKeywordsPrice: 1165705,
                    paidTraffic: 89391,
                    seKeywords: 0,
                },
            ],
        },
        overallScore: {
            totalPercentage: 75,
            listings: 'A',
            reviews: 'F',
            social: 'F',
            website: 'B',
            seo: 'A',
            googleAds: 'C',
        },
    },
};

// export default data;
